import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
// import "font-awesome/css/font-awesome.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/lib/integration/react";
import "core-js/stable";
import "react-phone-input-2/lib/material.css"; 
import { HashRouter } from "react-router-dom";
import "regenerator-runtime/runtime";
import App from "./App";
import { LoaderProvider } from "./contextApi/toggleLoader";
import "./index.css";
import store, { persistor } from "./store";
import { QueryClientProvider ,QueryClient} from "@tanstack/react-query";

const root = createRoot(document.getElementById("root"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: 3000, //10min
      // gcTime: 900000, //15 minutes
      refetchOnWindowFocus: true,
    },
  },

});
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <LoaderProvider>
          <HashRouter>
            <QueryClientProvider  client={queryClient}>
            <App />
            </QueryClientProvider>
          </HashRouter>
        </LoaderProvider>
      </LocalizationProvider>
    </PersistGate>
  </Provider>
);
